import util from '@/util'

export default {
  data: () => {
    return {
      arquivoSelecionado: null,
      cropperRef: null,
      flagImagemCarregada: false,
      adjustStencil: false
    }
  },
  methods: {
    abrirComponenteUpload () {
      this.$refs[this.uploadFileRef].bformFileClick()
    },
    ready () {
      this.flagImagemCarregada = true
    },
    async updateValue (blob) {
      const tamanhoBlobEhValido = this.validarTamanhoImagem(blob)
      if (tamanhoBlobEhValido) {
        blob = await this.redimensionarImagem(blob, 300)
        this.arquivoSelecionado = blob
        this.$emit('input', blob)
      } else {
        util.criarAlertaToastDeErro(this, 'Aviso', 'A imagem selecionada excede o tamanho máximo permitido de 5mb')
        this.arquivoSelecionado = null
        this.$emit('input', null)
      }
    },
    validarTamanhoImagem (blob) {
      try {
        // Tamanho máximo em bytes (5 MB)
        const tamanhoMaximo = 5 * (1024 * 1024)
        // Verificar se o tamanho do blob é menor ou igual ao tamanho máximo
        if (blob.size <= tamanhoMaximo) {
          // O blob tem tamanho válido
          return true
        } else {
          // O blob excede o tamanho máximo
          return false
        }
      } catch (e) {
        // Não foi possível validar, delega a validação para o back-end
        return true
      }
    },
    async redimensionarImagem (arquivoSelecionado, tamanhoDesejado) {
      try {
        const imagemRedimensionada = await this.executarPromiseRedimensionarImagem(arquivoSelecionado, tamanhoDesejado)
        return imagemRedimensionada
      } catch (e) {
        return arquivoSelecionado
      }
    },
    executarPromiseRedimensionarImagem (imagem, tamanhoDesejado) {
      return new Promise((resolve, reject) => {
        const img = new Image()
        img.onload = () => {
          const canvas = document.createElement('canvas')
          const context = canvas.getContext('2d')

          // Verificar se a imagem já possui as dimensões desejadas
          if (img.width === tamanhoDesejado && img.height === tamanhoDesejado) {
            // Liberar recursos
            URL.revokeObjectURL(imagem.src)

            // Converter o objeto Blob original para Blob novamente
            imagem = new Blob([imagem], { type: imagem.type })

            // Retornar a imagem original sem redimensionamento
            resolve(imagem)
            return
          }

          // Calcular as dimensões proporcionais para o tamanho desejado
          let novaLargura, novaAltura
          if (img.width > img.height) {
            novaLargura = tamanhoDesejado
            novaAltura = (tamanhoDesejado * img.height) / img.width
          } else {
            novaLargura = (tamanhoDesejado * img.width) / img.height
            novaAltura = tamanhoDesejado
          }

          // Criar um novo canvas com as dimensões desejadas
          canvas.width = tamanhoDesejado
          canvas.height = tamanhoDesejado

          // Preencher o canvas com fundo transparente
          context.clearRect(0, 0, canvas.width, canvas.height)

          // Calcular o deslocamento para centralizar a imagem redimensionada
          const deslocamentoX = (tamanhoDesejado - novaLargura) / 2
          const deslocamentoY = (tamanhoDesejado - novaAltura) / 2

          // Desenhar a imagem redimensionada no canvas
          context.drawImage(img, deslocamentoX, deslocamentoY, novaLargura, novaAltura)

          // Converter o canvas para Blob
          canvas.toBlob((blob) => {
            // Liberar recursos
            URL.revokeObjectURL(imagem.src)

            resolve(blob)
          }, 'image/png')
        }
        img.onerror = (error) => {
          // Liberar recursos
          URL.revokeObjectURL(imagem.src)

          reject(error)
        }
        img.src = URL.createObjectURL(imagem)
      })
    },
    defaultSize ({ imageSize, visibleArea }) {
      return {
        width: (visibleArea || imageSize).width,
        height: (visibleArea || imageSize).height
      }
    },
    zoom (factor) {
      this.$refs[this.cropperRef].zoom(factor)
    },

    center () {
      this.$refs[this.cropperRef].setCoordinates(({ coordinates, imageSize }) => ({
        left: imageSize.width / 2 - coordinates.width / 2,
        top: imageSize.height / 2 - coordinates.height / 2
      }))
    },

    reset () {
      this.$refs[this.cropperRef].reset()
    }
  }
}
